// Ce composant n'est plus nécessaire car les commandes sont créées depuis ProductDetail
// On le garde pour éviter les erreurs de routing
import React from "react";
import { useNavigate } from "react-router-dom";

const CreateOrder = () => {
  const navigate = useNavigate();
  
  React.useEffect(() => {
    navigate("/products");
  }, [navigate]);

  return null;
};

export default CreateOrder;
